import type { TDatadogErrorLog } from 'utils/datadog/types'

export const PAGINATION_LIMIT = 12

export const GET_OWNED_TOPICS_LOG: TDatadogErrorLog = {
  from: 'src/modules/territory/owned-topics-tab',
  name: 'Gets the workspace`s owned topics',
  message: 'Failed to fetch owned topics',
}
